import { NgModule } from '@angular/core';
import { TransferHotelComponent } from './hotel/transfer/transfer.component';
import { AngularMaterialModule } from '../../material.module';
import { HotelChainListComponent } from './hotel/hotel-chain-list/hotel-chain-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RoomTypeListComponent } from './hotel/room-type-list/room-type-list.component';
import { KeywordsComponent } from './hotel/keywords/keywords.component';

import { DirectiveModule } from '../../directives/directive.module';
import { InclusiveListComponent } from './hotel/inclusive-list/inclusive-list.component';
import { HotelExtrafFilterComponent } from './hotel/hotelfilter/hotelfilter.component';
import { PriceComponent } from './hotel/price/price.component';
import { CategoryComponent } from './hotel/category/category.component';
import { PercentComponent } from './hotel/percent/percent.component';
import { MeerComponent } from './hotel/meer/meer.component';
import { VerpflegungComponent } from './hotel/verpflegung/verpflegung.component';
import { DirektflugComponent } from './direktflug/direktflug.component';
import { AirportComponent } from './hotel/airport/airport.component';
import { FlightzeitComponent } from './flugzeit/flugzeit.component';
import { TouroperatorComponent } from './touroperator/touroperator.component';
import { FlightCarrierListComponent } from './flight-carrier-list/flight-carrier-list.component';
import { FlexibelComponent } from './hotel/flexibel/flexibel.component';
import { SelectedfiltersComponent } from './selectedfilters/selectedfilters.component';
import { RoomidComponent } from './hotel/roomid/roomid.component';
import { FacilityListComponent } from './hotel/facility-list/facility-list.component';
import { KlasseComponent } from './klasse/klasse.component';
import { DoublesliderComponent } from './doubleslider/doubleslider.component';
import { FlugExtrafilterComponent } from './flugfilter/flugfilter.component';
import { TravelclassComponent } from './travelclass/travelclass.component';
import { RecomcountComponent } from './hotel/recomcount/recomcount.component';
import { PreisalarmeComponent } from './preisalarme/preisalarme.component';
import { PipeModule } from '@app/pipe/pipe.module';
@NgModule({
    declarations: [
        TransferHotelComponent,
        HotelChainListComponent,
        RoomTypeListComponent,
        FlightzeitComponent,
        InclusiveListComponent,
        KeywordsComponent,
        HotelExtrafFilterComponent,
        PriceComponent,
        CategoryComponent,
        PercentComponent,
        MeerComponent,
        VerpflegungComponent,
        DirektflugComponent,
        RecomcountComponent,
        AirportComponent,
        TouroperatorComponent,
        FlightCarrierListComponent,
        FlexibelComponent,
        SelectedfiltersComponent,
        RoomidComponent,
        FacilityListComponent,
        KlasseComponent,
        DoublesliderComponent,
        FlugExtrafilterComponent,
        TravelclassComponent,
        PreisalarmeComponent
    ],
    imports: [
        AngularMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        PipeModule,
        DirectiveModule,
    ],
    exports: [
        HotelExtrafFilterComponent,
        SelectedfiltersComponent,
        FlugExtrafilterComponent
    ]
})
export class ExtrafiltersModule { }
